import * as yup from 'yup';
export const processingSummarySchema = yup.object({
    merchantAccountId: yup.number().required(),
    startDate: yup.date().required(),
    endDate: yup.date().required(),
});
//# sourceMappingURL=processingSummary.js.map